import { Order99 } from "../../../types/order99";

function differenceTwoDates(start: any, end: any) {
    const diffTime = Math.abs(end - start);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

export function computeOrders99(storesData: any, orders: Order99[]) {
    const end = new Date();
    end.setHours(23, 59, 59, 0);


    orders.forEach(order => {
        if (order.status === 'CON') {
            const saleDate = order.created_at.toDate();
            const differenceDate = differenceTwoDates(saleDate, end);
            if (differenceDate <= 28 && storesData[order.storeId]) {
                let totalPayInfo = 0;
                const payInfoData = order.payInfo as any;
                if (payInfoData) {
                    if (Array.isArray(payInfoData)) {
                        totalPayInfo = payInfoData.reduce(
                            (sum: number, p: any) => sum + (Number(p.fullValue) || 0),
                            0
                        );
                    } else {
                        totalPayInfo = Number(payInfoData.fullValue) || 0;
                    }
                }
                const deliveryFeeInCents = Number(order.deliveryFee) || 0;
                const total = totalPayInfo - deliveryFeeInCents;
                const index = 28 - differenceDate;
                if (storesData[order.storeId].data[index] !== undefined) {
                    storesData[order.storeId].data[index] += total;
                }
            }
        }
    });

}